const handleErrors: any = (res: Response) => {
  if (res.ok) {
    return res;
  }

  switch (res.status) {
    case 400: throw Error('INVALID_TOKEN');
    case 401: throw Error('UNAUTHORIZED');
    case 500: throw Error('INTERNAL_SERVER_ERROR');
    case 502: throw Error('BAD_GATEWAY');
    case 404: throw Error('NOT_FOUND');
    default: throw Error('UNHANDLED_ERROR');
  }
};

function parseXML(response: Response): Promise<Document> {
  return response.text().then((stringContainingXMLSource: any) => {
    const options = {};
    const parser: DOMParser = new DOMParser();
    return parser.parseFromString(stringContainingXMLSource, 'text/xml');
  });
}

export const fetchWithErrorHandling: any = (url: string, options: any) => fetch(url, options)
// 1. ネットワーク周りなどのリクエスト以前の段階でのエラーを処理する
  .catch((e) => { throw Error(e); })
// 2. サーバサイドで発行されたエラーステータスを処理する
  .then(handleErrors);

export const fetchToJsonWithErrorHandling: any = (url: string, options: any) => fetch(url, options)
// 1. ネットワーク周りなどのリクエスト以前の段階でのエラーを処理する
  .catch((e) => { throw Error(e); })
// 2. サーバサイドで発行されたエラーステータスを処理する
  .then(handleErrors)
// 3. 以上2つをパスした正常なレスポンスからJSONオブジェクトをパースする
  .then(res => res.json());

export function fetchToXmlWithErrorHandling(url: string, options: any): Promise<Document> {
  return fetch(url, options)
    // 1. ネットワーク周りなどのリクエスト以前の段階でのエラーを処理する
    .catch((e) => { throw Error(e); })
    // 2. サーバサイドで発行されたエラーステータスを処理する
    .then(handleErrors)
    // 3. 以上2つをパスした正常なレスポンスからJSONオブジェクトをパースする
    .then(parseXML)
    .catch((e) => { throw Error(e); });
}

/**
 * 渡されたenumオブジェクトと渡されたキーからenumのキーを返します。
 * 不正な値の場合は undefined が返されます。
 * @param enumObj enumのObject
 * @param key 文字列
 * @returns enumのキー | undefined
 */
export function convertEnum<T, S extends keyof T>(enumObj: T, key: S): T[keyof T] | undefined {
  return enumObj[key];
}
